import { Component } from '@angular/core';
import { App, NavController } from 'ionic-angular';
import { AccountLoginPage } from '../account-login/account-login';
import { AccountSignupPage } from '../account-signup/account-signup';

/**
 * Forgot Page
 * 
 * @export
 * @class AccountForgotPage
 */
@Component({
  selector: 'account-forgot',
  templateUrl: 'account-forgot.html'
})
export class AccountForgotPage {

  constructor(
    public app: App,
    public nav: NavController,
  ) { }

  ionViewDidEnter() {
    this.app.setTitle('Forgot Password');
  }

  onSignup() {
    this.nav.push(AccountSignupPage);
  }

  onLogin() {
    this.nav.push(AccountLoginPage);
  }

}


// WEBPACK FOOTER //
// ./src/pages/account-forgot/account-forgot.ts